import React from 'react';
import PropTypes from 'prop-types';
import Text from 'mineral-ui/Text';


const propTypes = {
  message: PropTypes.oneOfType(
    [
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ],
  ),
  fieldId: PropTypes.string,
};

const defaultProps = {
  message: undefined,
  fieldId: undefined,
};

export default function InlineMessage({
  message,
  fieldId,
  ...rest
}) {
  if (!message) {
    return null;
  }
  const displayMessage = typeof message === 'object' ? message.map(messageRow => (
    <React.Fragment key={messageRow}>
      <span>{messageRow}</span>
      <br />
    </React.Fragment>
  )) : message;
  return (
    <div id={`${fieldId}`}>
      <Text {...rest}>
        {displayMessage}
      </Text>
    </div>
  );
}
InlineMessage.propTypes = propTypes;
InlineMessage.defaultProps = defaultProps;
